var _rect, _rect2, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTalktous(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 48,
    viewBox: "0 0 49 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.333252,
    width: 48,
    height: 48,
    rx: 24,
    fill: "#E7EDFC"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_7847_26580",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 12,
    y: 12,
    width: 25,
    height: 24
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 12.3333,
    y: 12,
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_7847_26580)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.3333 33C24.0499 33 23.8124 32.9042 23.6208 32.7125C23.4291 32.5208 23.3333 32.2833 23.3333 32C23.3333 31.7167 23.4291 31.4792 23.6208 31.2875C23.8124 31.0958 24.0499 31 24.3333 31H31.3333V23.9C31.3333 21.95 30.6541 20.2958 29.2958 18.9375C27.9374 17.5792 26.2833 16.9 24.3333 16.9C22.3833 16.9 20.7291 17.5792 19.3708 18.9375C18.0124 20.2958 17.3333 21.95 17.3333 23.9V29C17.3333 29.2833 17.2374 29.5208 17.0458 29.7125C16.8541 29.9042 16.6166 30 16.3333 30C15.7833 30 15.3124 29.8042 14.9208 29.4125C14.5291 29.0208 14.3333 28.55 14.3333 28V26C14.3333 25.65 14.4208 25.3208 14.5958 25.0125C14.7708 24.7042 15.0166 24.4583 15.3333 24.275L15.4083 22.95C15.5416 21.8167 15.8708 20.7667 16.3958 19.8C16.9208 18.8333 17.5791 17.9917 18.3708 17.275C19.1624 16.5583 20.0708 16 21.0958 15.6C22.1208 15.2 23.1999 15 24.3333 15C25.4666 15 26.5416 15.2 27.5583 15.6C28.5749 16 29.4833 16.5542 30.2833 17.2625C31.0833 17.9708 31.7416 18.8083 32.2583 19.775C32.7749 20.7417 33.1083 21.7917 33.2583 22.925L33.3333 24.225C33.6499 24.375 33.8958 24.6 34.0708 24.9C34.2458 25.2 34.3333 25.5167 34.3333 25.85V28.15C34.3333 28.4833 34.2458 28.8 34.0708 29.1C33.8958 29.4 33.6499 29.625 33.3333 29.775V31C33.3333 31.55 33.1374 32.0208 32.7458 32.4125C32.3541 32.8042 31.8833 33 31.3333 33H24.3333ZM21.3333 26C21.0499 26 20.8124 25.9042 20.6208 25.7125C20.4291 25.5208 20.3333 25.2833 20.3333 25C20.3333 24.7167 20.4291 24.4792 20.6208 24.2875C20.8124 24.0958 21.0499 24 21.3333 24C21.6166 24 21.8541 24.0958 22.0458 24.2875C22.2374 24.4792 22.3333 24.7167 22.3333 25C22.3333 25.2833 22.2374 25.5208 22.0458 25.7125C21.8541 25.9042 21.6166 26 21.3333 26ZM27.3333 26C27.0499 26 26.8124 25.9042 26.6208 25.7125C26.4291 25.5208 26.3333 25.2833 26.3333 25C26.3333 24.7167 26.4291 24.4792 26.6208 24.2875C26.8124 24.0958 27.0499 24 27.3333 24C27.6166 24 27.8541 24.0958 28.0458 24.2875C28.2374 24.4792 28.3333 24.7167 28.3333 25C28.3333 25.2833 28.2374 25.5208 28.0458 25.7125C27.8541 25.9042 27.6166 26 27.3333 26ZM18.3583 24.45C18.2416 22.6833 18.7749 21.1667 19.9583 19.9C21.1416 18.6333 22.6166 18 24.3833 18C25.8666 18 27.1708 18.4708 28.2958 19.4125C29.4208 20.3542 30.0999 21.5583 30.3333 23.025C28.8166 23.0083 27.4208 22.6 26.1458 21.8C24.8708 21 23.8916 19.9167 23.2083 18.55C22.9416 19.8833 22.3791 21.0708 21.5208 22.1125C20.6624 23.1542 19.6083 23.9333 18.3583 24.45Z",
    fill: "#41558D"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTalktous);
export default __webpack_public_path__ + "static/media/talktous.8c8066603e59d05e19c088cee70c65ad.svg";
export { ForwardRef as ReactComponent };